module.exports = __webpack_public_path__ + "static/media/md-git-compare.553bbece.svg";